<template>
  <div v-if="header.value === 'user'">
    <user-item :user="item.user" />
  </div>
  <div v-else-if="header.value === 'instance'">
    <a v-if="instance" :href="instance.url" target="_blank" class="logs-table__instance text-truncate">{{ instance.name }}</a>
  </div>
  <div v-else-if="header.value === 'action'">
    <log-item :action="item" />
  </div>
  <div
    v-else-if="header.value === 'date'"
    :class="isMobile ? '' : 'actions-row'"
  >
    <v-tooltip open-delay="150" close-delay="150" offset-y bottom>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="mb-0 text-right gray--text text--darken-1"
        >
          {{ moment(item.date).fromNow() }}
        </span>
      </template>
      <span>{{ moment(item.date).format("YYYY-MM-DD HH:mm") }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    {{ item[header.value] }}
  </div>
</template>

<script>
import moment from "moment";
import UserItem from "@/components/logs/UserItem.vue";
import LogItem from "@/components/logs/LogItem.vue";

export default {
  components: {
    UserItem,
    LogItem,
  },
  props: {
    item: Object,
    header: Object,
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
    };
  },
  computed: {
    instance() {
      let instance = null;
      for (const [key, value] of Object.entries(this.item.payload)) {
        if (key.startsWith("App\\Models\\Application:")) {
          instance = value;
          break;
        }
      }
      return instance;
    },
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>
<style lang="scss">
.v-application{
    .logs-table{
        &__instance{
            display: inline-block;
            max-width: 150px;
            color:var(--v-text-darken2);
            font-weight: 700;
            transition: color 0.3s ease;
            &:hover{
                color:var(--v-primary-base);
            }
        }
        &__log-item{
            max-width: 480px;
            .information{
                flex: 1;             
                min-width: 0;        
                overflow: hidden;      
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block !important;
                br{
                    display: none;
                }
                b{
                    margin-right: 4px;
                }
            }
        }
        .user-item{
            &__name{
                white-space: nowrap;
            }
        }
        .log-table_action{
            max-width: 100%;
            white-space: nowrap;
        }
        .actions-row{
            white-space: nowrap;
        }
    }
}
</style>